import { BWICS } from '@/creditflowresearch/domain/BondType';

const getBwicsInventoryMeta = (bondType, assetClassAbbreviation) => ({
  title: `Fixed Income ${ assetClassAbbreviation } ${ bondType === BWICS ? 'BWICS' : 'Inventories' }`,
  description: 'Supercharge your ABS BWIC & Inventory discovery process. Seamlessly explore BWICS & Inventory from participating dealers.',
});

export default {
  getHomePage: () => ({
    title: 'Supersonic Insights and Analysis for Debt Capital Markets | CreditFlow',
    description: 'Supersonic Insights and Analysis for Debt Capital Markets.',
  }),
  getSubscriptions: () => ({
    title: 'Email Subscriptions',
    description: 'All your email subscriptions in one place, customize information that you want to receive from Finsight.com',
  }),
  getABSBondScreener: () => ({
    title: 'Fixed Income ABS Bond Screener',
    description: 'Use our fixed income screener for global ABS bonds for free. Filter 40,000+ bonds across all sectors using dozens of criteria.',
  }),
  getCorporateBondscreener: () => ({
    title: 'Fixed Income Corporate Bond Screener',
    description: 'Use our fixed income screener for global corporate bonds for free. Filter 40,000+ bonds across all industries using dozens of criteria.',
  }),
  getBwicsInventory: getBwicsInventoryMeta,
  getBwicsInventorySummary: getBwicsInventoryMeta,
  getIndustryProfile: (industryName) => ({
    title: `${ industryName }  Industry Bond Issuance Overview `,
    description: `View recent and historical corporate bond new issue pricing, volume and ratings in the ${ industryName } industry.`,
  }),
  getIndustrySubindustryProfile: (industrySubindustryName) => ({
    title: ` ${ industrySubindustryName } Bond Issuance Overview`,
    description: `View recent and historical corporate bond new issue pricing, volume and ratings in the ${ industrySubindustryName } subindustry.`,
  }),

  getMarketOverviewHYC: () => ({
    title: 'High Yield Bond Issuance Overview',
    description: 'Recent and historical global high yield bond new issue pricing, volume and ratings tracker.',
  }),
  getMarketOverviewIGC: () => ({
    title: 'Investment Grade Bond Issuance Overview',
    description: 'Recent and historical global investment grade bond new issue pricing, volume and ratings tracker.',
  }),
  getMarketOverviewUsAbs: () => ({
    title: 'ABS Bond Issuance Overview',
    description: 'View recent and historical global ABS new issue pricing, volume and research across Auto, CLO, CMBS, Credit Card, Equipment, Esoteric, Student Loans and RMBS.',
  }),
  getEmMarketOverview: () => ({
    title: 'Emerging Market Bond Issuance Overview',
    description: 'Recent and historical Emerging Markets bond market data covering issuance activity, deal flow, pricing, new issue volume, top underwriters and market commentary',
  }),
  getMarketOverviewCustomer: () => ({
    title: 'ABS (ex CLO, CMBS & RMBS) Issuance Overview',
    description: 'View recent and historical global ABS new issue pricing, volume and research across Auto, Credit Card, Equipment, Esoteric and Student Loan ABS.',
  }),
  getResearch: () => ({
    title: 'Fixed Income Research & Presale Reports',
    description: 'Explore free fixed income research across corporate bonds and asset-backed securities from leading rating agencies and research providers here.',
  }),
  getSectorProfile: (sector) => ({
    title: `${ sector } Sector Bond Issuance Overview`,
    description: `View recent and historical ABS new issue pricing, volume and ratings in the ${ sector } sector here.`,
  }),
  getSectorSubsectorProfile: (sectorSubsectorName) => ({
    title: `${ sectorSubsectorName } ABS Bond Issuance Overview`,
    description: `View recent and historical ABS new issue pricing, volume and ratings in the ${ sectorSubsectorName } sector here.`,
  }),
  getLoanLevelData: () => ({
    title: 'US ABS Loan Level Data on EDGAR Tracker',
    description: 'View and track the latest ABS-EE loan level-data filings on EDGAR here.',
  }),
  getNewIssuePipeline: () => ({
    title: 'US ABS New Issue Pipeline & 15G Tracker',
    description: 'View and track the latest ABS-15G new issue filings on EDGAR here.',
  }),
  getStratMaker: (filingTitle) => ({
    title: 'US ABS Loan Level Data StratMaker',
    description: `View ${ filingTitle } loan-level data stratifications on CreditFlow's stratmaker.`,
  }),
  leagueTable: () => ({
    title: 'Fixed Income Underwriter Rating Agency League Table',
    description: 'View and track the latest global fixed Income league table for underwriters and rating agencies here.',
  }),
  underwriterRatingAgency: (companyName) => ({
    title: `${ companyName } League Table Ranking`,
    description: `View ${ companyName } fixed income league table profile here.`,
  }),
  getCatalogIssuers: () => ({
    title: 'Global Fixed Income Issuers',
    description: 'View a list of all global fixed income issuers tracked by FINSIGHT.',
  }),
  getCatalogSponsors: () => ({
    title: 'Global Fixed Income Parents',
    description: 'View a list of all global fixed income parents tracked by FINSIGHT.',
  }),
  getPricing: () => ({
    title: 'Pricing and Plans',
    description: 'Subscribe for access to industry leading fixed income new issue and secondary market data, news and research.',
  }),
  getPrivacyPolicyExcelAddIn: () => ({
    title: 'Privacy Policy for CreditFlow for Excel',
    description: '',
  }),
};
